import { Component, inject, Inject, Input, OnInit } from '@angular/core';
import { EventComplete } from '../../../../data-services/models/events/event-complete.model';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { EventHelper } from '../../../../data-services/helpers/events.helper';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressBarComponent } from '../../../../core/progress-bar/feature/progress-bar.component';
import { AdminEventWizardComponent } from '../../manage/admin-event-wizard/feature/admin-event-wizard.component';

@Component({
  selector: 'app-admin-event-summary',
  imports: [CommonModule,RouterModule,ProgressBarModule,ProgressBarComponent,AdminEventWizardComponent],
  templateUrl: '../ui/summary.component.html',
  styleUrl: '../ui/summary.component.css'
})
export class AdminEventSummaryComponent implements OnInit {
  private readonly _route = inject(ActivatedRoute);
  @Input() event?: EventComplete;
  public _eventHelper!: EventHelper;
  wizard:boolean = (this._route.snapshot.queryParams["show_wizard"] === 'true')

  ngOnInit(): void {
    this._eventHelper = new EventHelper(this.event!);
  }

  get eventPassed(): boolean {
    return new Date(this.event!.eventEnd) < new Date() && !this.event!.cancelled
  }
}